/**
 * Image with Text + Press Section
 * - Desktop: Slider OR column layout based on setting
 * - Mobile: Slider OR column layout based on setting
 */

window.initImageWithTextPressSlider = function (container) {
  const desktopSlider = container.querySelector('.press-tabs__slider--desktop');
  const mobileSlider = container.querySelector('.press-tabs__slider--mobile');
  const desktopLayout = container.dataset.desktopPressLayout;
  const mobileLayout = container.dataset.mobilePressLayout;

  if (typeof Splide === 'undefined') {
    return null;
  }

  let desktopSplideInstance = null;
  let mobileSplideInstance = null;

  const isMobile = () => window.innerWidth < 768;

  const getSplideConfig = (autoplay) => ({
    type: 'loop',
    perPage: 1,
    perMove: 1,
    gap: 30,
    arrows: false,
    pagination: false,
    drag: true,
    autoplay: autoplay,
    interval: 5000,
    pauseOnHover: true,
    pauseOnFocus: true,
    speed: 800,
    easing: 'ease',
    direction: 'ltr',
    trimSpace: false,
    focus: 0,
    updateOnMove: true,
    i18n: {
      carousel: 'Press mentions carousel',
      slide: 'press item',
      slideLabel: '%s of %s',
    }
  });

  const mountDesktopSlider = () => {
    if (isMobile() || desktopSplideInstance || !desktopSlider || desktopLayout !== 'slider') return;

    const autoplay = container.dataset.sliderAutoplay === 'true';
    desktopSplideInstance = new Splide(desktopSlider, getSplideConfig(autoplay));
    desktopSplideInstance.mount();
  };

  const destroyDesktopSlider = () => {
    if (desktopSplideInstance) {
      desktopSplideInstance.destroy();
      desktopSplideInstance = null;
    }
  };

  const mountMobileSlider = () => {
    if (!isMobile() || mobileSplideInstance || !mobileSlider || mobileLayout !== 'slider') return;

    const autoplay = container.dataset.sliderAutoplay === 'true';
    mobileSplideInstance = new Splide(mobileSlider, getSplideConfig(autoplay));
    mobileSplideInstance.mount();
  };

  const destroyMobileSlider = () => {
    if (mobileSplideInstance) {
      mobileSplideInstance.destroy();
      mobileSplideInstance = null;
    }
  };

  const handleResize = () => {
    if (isMobile()) {
      destroyDesktopSlider();
      mountMobileSlider();
    } else {
      destroyMobileSlider();
      mountDesktopSlider();
    }
  };

  // Initial mount
  handleResize();

  // Handle window resize with debounce
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, 150);
  });

  // Store instances on container for cleanup
  container.desktopSplideInstance = desktopSplideInstance;
  container.mobileSplideInstance = mobileSplideInstance;

  return { desktopSplideInstance, mobileSplideInstance };
};

class ImageWithTextPressTabs {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('.press-tabs__tab');
    this.panels = container.querySelectorAll('.press-tabs__panel');

    this.init();
  }

  init() {
    // Initialize desktop tabs if they exist
    if (this.tabs.length > 0 && this.panels.length > 0) {
      this.initTabs();
    }

    // Initialize mobile slider
    window.initImageWithTextPressSlider(this.container);
  }

  initTabs() {
    // Add click listeners to tabs
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.switchTab(index));

      // Keyboard navigation
      tab.addEventListener('keydown', (e) => this.handleKeydown(e, index));
    });
  }

  switchTab(index) {
    // Deactivate all tabs and panels
    this.tabs.forEach(tab => {
      tab.classList.remove('press-tabs__tab--active');
      tab.setAttribute('aria-selected', 'false');
    });

    this.panels.forEach(panel => {
      panel.classList.remove('press-tabs__panel--active');
    });

    // Activate selected tab and panel
    this.tabs[index].classList.add('press-tabs__tab--active');
    this.tabs[index].setAttribute('aria-selected', 'true');

    this.panels[index].classList.add('press-tabs__panel--active');
  }

  handleKeydown(e, currentIndex) {
    let newIndex = currentIndex;

    switch (e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        newIndex = currentIndex === 0 ? this.tabs.length - 1 : currentIndex - 1;
        break;
      case 'ArrowRight':
        e.preventDefault();
        newIndex = currentIndex === this.tabs.length - 1 ? 0 : currentIndex + 1;
        break;
      case 'Home':
        e.preventDefault();
        newIndex = 0;
        break;
      case 'End':
        e.preventDefault();
        newIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    this.tabs[newIndex].focus();
    this.switchTab(newIndex);
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.image-with-text-press');
  sections.forEach(section => new ImageWithTextPressTabs(section));
});

// Initialize on Shopify theme editor section load
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.image-with-text-press');
    if (section) {
      new ImageWithTextPressTabs(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const container = event.target.querySelector('.image-with-text-press');
    if (container) {
      if (container.desktopSplideInstance) {
        container.desktopSplideInstance.destroy();
      }
      if (container.mobileSplideInstance) {
        container.mobileSplideInstance.destroy();
      }
    }
  });
}
